export const trackEvent = (eventName, params = {}) => {
    if(!gtag) return
    gtag('event', eventName, params);
}